import { Card } from 'antd';
import { useState } from 'react';
import { AcquiredPropertiesTable } from '../AcquiredPropertiesTable';
import { showErrorToast } from '../../../../../../services/notificationsService';
import { useGetTitleOrganizationTransactions } from '../../../../../../queries/TitleOrganization';

export const Transactions = ({
  isMultiFamilySelected,
  isVacantSelected,
  selectedRange,
  postgresId,
  appliedFilters,
}) => {
  const [filteredCount, setFilteredCount] = useState(0);
  const {
    data: transactionsData,
    isLoading: isTransactionsLoading,
    isError: isTransactionsError,
  } = useGetTitleOrganizationTransactions({
    selectedRange,
    postgresId,
    appliedFilters,
  });

  if (isTransactionsError) {
    showErrorToast('Fetching transactions failed!');
  }

  return (
    <>
      <Card
        title={`Recent transactions (${
          filteredCount || transactionsData?.length || 0
        })`}
      >
        <AcquiredPropertiesTable
          isLoading={isTransactionsLoading}
          data={transactionsData}
          isMultiFamilySelected={isMultiFamilySelected}
          isVacantSelected={isVacantSelected}
          setFilteredCount={setFilteredCount}
        />
      </Card>
    </>
  );
};
